const dotenv = require('dotenv');
dotenv.config();
module.exports = {
  natus_env: process.env.REACT_APP_NATUS_ENV,
  CHAT_SOCKET_HOST: process.env.REACT_APP_NATUS_ENV == "production" ? 'wss://chatsocket.petinoks.com' : 'wss://chatsocket-uat.petinoks.com',
};